import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { LogoGoogle, LogoFacebook } from "./authLogo";

import "./SocialAuth.css";

const SocialLogin = ({ text }) => {
  return (
    <>
      <Row>
        <Col md={12} lg={6}>
          <a
            href={`${process.env.NEXT_PUBLIC_API_URL}/login/google`}
            className="text-decoration-none"
          >
            <button className="btn-login btn mb-2" type="button">
              <div className="btn-login-icon">
                <LogoGoogle />
              </div>
              <span>{text} Google</span>
            </button>
          </a>
        </Col>
        <Col md={12} lg={6}>
          <a
            href={`${process.env.NEXT_PUBLIC_API_URL}/login/facebook`}
            className="text-decoration-none"
          >
            <button className="btn-login btn mb-2" type="button">
              <div className="btn-login-icon">
                <LogoFacebook />
              </div>
              <span>{text} Facebook</span>
            </button>
          </a>
        </Col>
      </Row>
    </>
  );
};

export default SocialLogin;
